/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Row_OssInputs */

const en_cmp_row_oss = /** @type {(inputs: Cmp_Row_OssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open-source CLI`)
};

const id_cmp_row_oss = /** @type {(inputs: Cmp_Row_OssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI open-source`)
};

/**
* | output |
* | --- |
* | "Open-source CLI" |
*
* @param {Cmp_Row_OssInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_row_oss = /** @type {((inputs?: Cmp_Row_OssInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Row_OssInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_row_oss(inputs)
	return en_cmp_row_oss(inputs)
});